import GPTsearchbar from "./GPTsearchbar";
import { backgroundImage } from "../utils/images";
import GPTafterresult from "./GPTafterresult";
import { useSelector } from "react-redux";

function GPTsearchPage() {
  return (
    <div className="bg-gray-800 h-[100vh]">
      
      <GPTsearchbar />
      <GPTafterresult />
    </div>
  );
}
export default GPTsearchPage;
